import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

// Export to CSV
export const exportToCSV = (data, columns, filename) => {
  if (!data || !data.length) return;

  // Prepare headers
  const headers = columns.map((col) => col.label);

  // Prepare rows
  const rows = data.map((item) => {
    return columns.map((col) => {
      // Handle custom cell renderers by using the raw data
      return item[col.key] !== undefined ? String(item[col.key]) : "";
    });
  });

  // Combine headers and rows
  const csvContent = [headers, ...rows].map((row) => row.join(",")).join("\n");

  // Create blob and download
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8" });
  saveAs(blob, `${filename}-${new Date().toISOString().split("T")[0]}.csv`);
};

// Export to Excel
export const exportToExcel = (data, columns, filename) => {
  if (!data || !data.length) return;

  // Prepare headers
  const headers = columns.map((col) => col.label);

  // Prepare rows
  const rows = data.map((item) => {
    return columns.map((col) => {
      // Handle custom cell renderers by using the raw data
      return item[col.key];
    });
  });

  // Create worksheet
  const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);

  // Create workbook
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

  // Generate Excel file and download
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `${filename}-${new Date().toISOString().split("T")[0]}.xlsx`);
};
